// extracted by mini-css-extract-plugin
export default {"iframe":"DrawerIframe_iframe__FyK3y"};